module.exports = __webpack_public_path__ + "static/media/kasumin.c6e5cd74.png";


//////////////////
// WEBPACK FOOTER
// ./src/css/img/tabla_oport/banano/climasense/moco_bacteriano/curativa/kasumin.png
// module id = 1164
// module chunks = 3